import Swiper, { Pagination, Autoplay } from "swiper";

export const initSliderSlider = () => {
  let slider = document.querySelector('.wp-block-slider .swiper')

  if(slider) {
    let count = $('.wp-block-slider .swiper-wrapper').children().length

    if (count > 1) {
      new Swiper(slider, {
        modules: [Pagination, Autoplay],
        centeredSlides: true,
        autoHeight: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          bulletClass: 'h-2 w-full inline-block cursor-pointer',
          bulletActiveClass: 'active bg-primary-500 -mb-1 relative',
          hideOnClick: false,
          horizontalClass: 'relative w-full flex z-[1] bg-gray-200'
        }
      })
    }
  }
}

export const initEditorSliderSlider = () => {
  let slider = document.querySelector('[data-type="acf/slider"]')

  if(slider) {
    let blockWidth = slider.offsetWidth
    let sliders = document.querySelectorAll('[data-type="acf/slider"] .swiper')

    sliders.forEach((slider) => {
      let slides = slider.querySelectorAll('.swiper-slide')
      let wrapper = slider.querySelector('.swiper-wrapper')
      let paginationWrapper = slider.querySelector('.swiper-pagination-wrapper')
      let pagination = slider.querySelector('.swiper-pagination')
      let slidesCount = slides.length

      wrapper.style.width = blockWidth * slidesCount + 'px'

      slides.forEach((slide) => {
        slide.style.float = 'left'
        slide.style.width = blockWidth + 'px'
      })

      pagination.append(...[
        document.createElement('span'),
        document.createElement('span'),
        document.createElement('span')
      ])

      let bullets = pagination.querySelectorAll('span')
      bullets[0].classList.add('active')

      bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', (event) => {
          let distance = blockWidth * index + 1
          wrapper.style.left = - distance + 'px'
          bullets.forEach((bullet) => {
            bullet.classList.remove('active')
          })
          bullet.classList.add('active')
        })
      })
    })

      // .acf-field-slider-slider-block-active

    const aspectRatio = document.querySelector('[data-type="aspect_ratio"]');

    const sliderChangeObserver = new MutationObserver(() => {
      if (aspectRatio) {
        if (!aspectRatio.classList.contains('soundest-form-embedded-v2-hidden')) {
          sliderChangeObserver.disconnect()
          sliders.forEach((slider) => {
            let slides = slider.querySelectorAll('.swiper-slide')
            let wrapper = slider.querySelector('.swiper-wrapper')
            let paginationWrapper = slider.querySelector('.swiper-pagination-wrapper')
            let pagination = slider.querySelector('.swiper-pagination')
            let slidesCount = slides.length

            wrapper.style.width = blockWidth * slidesCount + 'px'

            slides.forEach((slide) => {
              slide.style.float = 'left'
              slide.style.width = blockWidth + 'px'
            })

            while (pagination.firstChild) {
              pagination.removeChild(pagination.firstChild);
            }

            pagination.append(...[
              document.createElement('span'),
              document.createElement('span'),
              document.createElement('span')
            ])

            let bullets = pagination.querySelectorAll('span')
            bullets[0].classList.add('active')

            bullets.forEach((bullet, index) => {
              bullet.addEventListener('click', (event) => {
                let distance = blockWidth * index + 1
                wrapper.style.left = - distance + 'px'
                bullets.forEach((bullet) => {
                  bullet.classList.remove('active')
                })
                bullet.classList.add('active')
              })
            })
          })
        }
      }
    })

    sliderChangeObserver.observe(aspectRatio, {
      attributes: true,
      childList: true,
      subtree: true
    })
  }
}
